/**
 * sl-728o.7.3: Database Basics Tutorial Session
 *
 * 4 steps guiding the user through creating a database on the canvas.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';
import {
  ensureEdgelessMode,
  resolveDatabase,
  resolveEdgelessToolbar,
  resolveEdgelessViewport,
} from './targets';

type I18n = ReturnType<typeof useI18n>;

export function createDatabaseBasicsSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:database-basics',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        targetResolver: resolveEdgelessViewport,
        title:
          t['com.streamlain.streamlain.tutorial.database-basics.step1.title'](),
        content:
          t[
            'com.streamlain.streamlain.tutorial.database-basics.step1.content'
          ](),
        animation: 'none',
        onEnter: ensureEdgelessMode,
        delay: 650,
        trigger: { type: 'manual' },
        position: 'auto',
      },
      {
        targetResolver: resolveEdgelessToolbar,
        title:
          t['com.streamlain.streamlain.tutorial.database-basics.step2.title'](),
        content:
          t[
            'com.streamlain.streamlain.tutorial.database-basics.step2.content'
          ](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'top',
      },
      {
        targetResolver: resolveDatabase,
        title:
          t['com.streamlain.streamlain.tutorial.database-basics.step3.title'](),
        content:
          t[
            'com.streamlain.streamlain.tutorial.database-basics.step3.content'
          ](),
        animation: 'highlight',
        trigger: { type: 'manual' },
        position: 'right',
      },
      {
        targetResolver: resolveDatabase,
        title:
          t['com.streamlain.streamlain.tutorial.database-basics.step4.title'](),
        content:
          t[
            'com.streamlain.streamlain.tutorial.database-basics.step4.content'
          ](),
        animation: 'highlight',
        trigger: { type: 'manual' },
        position: 'top',
      },
    ],
  };
}
